import { lazy } from "react";
// admin
const Dashboard = lazy(() => import("../admin-pages/dashboard"));

const Customer = lazy(() => import("../admin-pages/customer"));



const Viewcustomer = lazy(() => import("../admin-pages/customer/component/viewcustomer"));

const UserAccount = lazy(() => import("../admin-pages/useraccountt"));

const Adduser = lazy(() => import("../admin-pages/useraccountt/components/Adduser"));
const Addrole  = lazy(() => import("../admin-pages/useraccountt/components/Addrole"));

const Rolelist  = lazy(() => import("../admin-pages/useraccountt/components/rolelist"));
const Zone  = lazy(() => import("../admin-pages/zone"));
const Addzone = lazy(() => import("../admin-pages/zone/components/addzone"));
const Viewzone  = lazy(() => import("../admin-pages/zone/components/viewzone"));
const Vendor  = lazy(() => import("../admin-pages/vendor"));
const VendorView  = lazy(() => import("../admin-pages/vendor/components/vendorview"));
const Reports  = lazy(() => import("../admin-pages/report"));

const Settings = lazy(() => import("../admin-pages/Settings"));
const Services  = lazy(() => import("../admin-pages/services"));

const Bookings  = lazy(() => import("../admin-pages/booking"));
const VendorBookingDetails  = lazy(() => import("../admin-pages/booking/components"));
const ViewServicesadmin   = lazy(() => import("../admin-pages/services/components/viewservices/viewservices"));
const  Notification  = lazy(() => import("../admin-pages/notification"));
const   HeroUploader  = lazy(() => import("../admin-pages/Herosection"));


















// vendor
const VendorDashboard  = lazy(() => import("../vendor-pages/dashboard"));

const VendorBookings  = lazy(() => import("../vendor-pages/booking"));
const VendorServices  = lazy(() => import("../vendor-pages/services"));


const VendorReports  = lazy(() => import("../vendor-pages/report"));
const VendorSettings   = lazy(() => import("../vendor-pages/Settings"));

const Addservce   = lazy(() => import("../vendor-pages/services/components/addservce"));
const Viewservices   = lazy(() => import("../vendor-pages/services/components/viewservices/viewservices"));
const EditService   = lazy(() => import("../vendor-pages/services/components/editservice"));
const BookingDetails  = lazy(() => import("../vendor-pages/booking/components"));
const VendorNotification  = lazy(() => import("../vendor-pages/notification"));

const VendorVerified  = lazy(() => import("../auth/adminauth/vendorverifiy"));









// 

// Admin routes
export const adminRoutes = [
  {
    path: "/admin",
    component: Dashboard,
  },
  {
    path: "/admin/customer",
    component: Customer,
  },

  {
    path: "/admin/customer/viewcustomer",
    component: Viewcustomer,
  },

  {
    path: "/admin/useraccount",
    component: UserAccount,
  },

  {
    path: "/admin/useraccount/adduser",
    component: Adduser,
  },

  {
    path: "/admin/useraccount/addrole",
    component: Addrole,
  },

  {
    path: "/admin/useraccount/adduser/rolelist",
    component: Rolelist,
  },
  {
    path: "/admin/zone",
    component: Zone,
  },
  {
    path: "/admin/zone/addzone",
    component: Addzone,
  },

  {
    path: "/admin/zone/viewzone",
    component: Viewzone,
  },


  {
    path: "/admin/vendor",
    component: Vendor,
  },
  {
    path: "/admin/vendor/vendorveiw",
    component: VendorView,
  },

  {
    path: "/admin/report",
    component: Reports,
  },
  {
    path: "/admin/services",
    component: Services,
  },
  {
    path: "/admin/services/viewservice",
    component: ViewServicesadmin,
  },
  {
    path: "/admin/settings",
    component: Settings,
  },

  {
    path: "/admin/booking",
    component: Bookings,
  },
  {
    path: "/admin/booking/bookingview",
    component: VendorBookingDetails,
  },
  
  {
    path: "/admin/notification",
    component: Notification,
  },
  {
    path: "/admin/herosection",
    component: HeroUploader,
  },
];











// vendor
export const vendorRoutes = [
  {
    path: "/vendor",
    component: VendorDashboard,
  },

  {
    path: "/vendor/booking",
    component: VendorBookings ,
  },
  {
    path: "/vendor/services",
    component: VendorServices ,
  },
  {
    path: "/vendor/addservice",
    component: Addservce,
  },
  {
    path: "/vendor/viewservice",
    component: Viewservices,
  },
  {
    path: "/vendor/report",
    component: VendorReports,
  },

  {
    path: "/vendor/settings",
    component: VendorSettings,
  },
  {
    path: "/vendor/editservice",
    component: EditService,
  },
  {
    path: "/vendor/booking/Viewbooking",
    component: BookingDetails,
  },


  {
    path: "/vendor/notification",
    component: VendorNotification,
  },


];


export default { adminRoutes, vendorRoutes };
